module.exports = __webpack_public_path__ + "img/6.1529dc63.png";